// // // app/helpers/interactions/handlersMouseUp.js

import { calculatePolygonArea, calculatePolygonPerimeter } from "../geometry";

export function makeHandleMouseUp(ctx) {
  return function handleMouseUp() {
    if (ctx.isDraggingDot) {
      ctx.setIsDraggingDot(false);
      ctx.setDraggedDotId(null);
      ctx.addToHistory?.(); // snapshot after drag
      return;
    }
    if (ctx.isDraggingArrow) {
      ctx.addToHistory?.();
    }
    ctx.setIsDraggingArrow(false);
    ctx.setDraggedArrowId(null);
    ctx.setArrowDragMode(null);

    if (
      ctx.isDragging ||
      ctx.isDraggingLine ||
      ctx.isDraggingScale ||
      ctx.isDraggingScaleEnd ||
      ctx.isDraggingText ||
      ctx.isDraggingGuideline ||
      ctx.isDraggingPolygon ||
      ctx.isResizingText ||
      ctx.isRotatingText
    ) {
      ctx.addToHistory();
    }

    // Reset dragging flags
    ctx.setIsDragging(false);
    ctx.setDragPoint(null);
    ctx.setIsDraggingLine(false);
    ctx.setDraggedLineId(null);
    ctx.setIsDraggingScale(false);
    ctx.setIsDraggingScaleEnd(false);
    ctx.setIsDraggingText(false);
    ctx.setDraggedTextId(null);
    ctx.setIsDraggingGuideline(false);
    ctx.setDraggedGuidelineId(null);
    ctx.setIsDraggingPolygon(false);
    ctx.setDraggedPolygonId(null);
    ctx.setDraggedPointIndex(null);
    ctx.setIsPanning(false);
    ctx.setLastPanPoint(null);
    ctx.setIsResizingText(false);
    ctx.setTextResizeHandle(null);
    ctx.setIsRotatingText(false);
    ctx.setSelectedDot(null);

    if (ctx.isPanning) {
      return;
    }

    if (ctx.isDraggingText || ctx.isResizingText || ctx.isRotatingText) {
      ctx.setIsDraggingText(false);
      ctx.setIsResizingText(false);
      ctx.setIsRotatingText(false);
      ctx.setDraggedTextId(null);
      ctx.setTextResizeHandle(null);
      ctx.addToHistory?.();
    }
    // ---- 🔑 Use helpers for polygon measurements ----
    if (ctx.isDraggingPolygon || ctx.draggedPolygonId) {
      const updated = ctx.polygons.map((poly) => {
        const area = calculatePolygonArea(
          poly.points,
          ctx.scale,
          ctx.scaleLength,
          ctx.fabricCanvasRef
        );
        const perimeter = calculatePolygonPerimeter(poly.points, (a, b) =>
          Math.hypot(b.x - a.x, b.y - a.y)
        );

        return {
          id: poly.id,
          type: "polygon",
          points: poly.points,
          area,
          perimeter,
          unit: "px", // or your converted unit if using scale/scaleLength
        };
      });

      ctx.updateMeasurementRunTime(updated);
    } else {
      ctx.updateMeasurementRunTime(ctx.measurements);
    }
  };
}
